import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router's <BrowserRouter> does not reset scroll on navigation, so
// clicking a link while scrolled down lands the new page at the old scroll
// position. This resets to the top whenever the pathname changes. In-page
// anchor (#hash) links are left to the browser's native behaviour.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}
